import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function StarViewTerms() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.legalEyebrow')}
      title={t('legalPages.starviewTerms.title')}
      subtitle={t('legalPages.starviewTerms.subtitle')}
    >
      {/* Legal text is deliberately NOT machine-translated: a translation
          nobody has legally reviewed would carry meaning no one signed off
          on. The chrome localizes; the binding text stays English, and says
          so in the reader's language. */}
      <p className="info-english-notice"><em>{t('info.englishNotice')}</em></p>
      <p className="info-updated">Last updated: January 2026</p>

      <h2>Tickets</h2>
      <ul>
        <li>A ticket reserves one specific seat, in one specific auditorium, for one specific showtime and date - it is not valid for a different showing.</li>
        <li>Tickets are valid for 24 hours from the booked showtime. After that window, an unclaimed or unused ticket expires and the seat becomes available to other guests.</li>
        <li>A ticket can be shared with another registered StarView account; the recipient must claim it before the 24-hour window closes.</li>
      </ul>

      <h2>Seating</h2>
      <p>
        Seat maps reflect real-time availability. Once you select and pay for a seat, it's held exclusively for
        you until your ticket's 24-hour window ends - at which point, if unused, it's released back into the
        pool for that showtime's next occurrence.
      </p>

      <h2>Auditorium Assignment</h2>
      <p>
        StarView automatically assigns the first available auditorium with open capacity for your chosen movie
        and showtime, and opens an additional auditorium automatically if every existing one is full - so a
        popular showtime is never simply "sold out" the way a single fixed-capacity room would be.
      </p>

      <h2>Refunds and Changes</h2>
      <p>
        Ticket purchases made with Galaxies or a credit/debit card are final once the showtime countdown has
        started, except where required by local law or where StarView cancels a showing. Contact support before
        your showtime if you believe there's been a genuine error with your booking.
      </p>

      <h2>StarView X Membership</h2>
      <p>
        StarView X is a paid membership tier that includes a free monthly ticket and free medium popcorn, on top
        of standard Galaxies earning. Membership renews automatically until cancelled from your account settings.
      </p>

      <h2>Conduct in the Auditorium</h2>
      <p>
        Recording, photographing, or otherwise capturing any portion of a film is prohibited and may result in
        removal from the theater and account suspension, consistent with studio anti-piracy requirements.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about a specific booking can be sent to{' '}
        <a href="mailto:support@starviewcinema.com">support@starviewcinema.com</a>, or asked directly through the
        in-app support assistant.
      </p>
    </InfoPage>
  );
}
